// extracted by mini-css-extract-plugin
module.exports = {"root":"create_dialog_content_root__1zQwN","menu":"create_dialog_content_menu__3aOzg","content":"create_dialog_content_content__2PTTI","inner":"create_dialog_content_inner__37_fQ"};